import Color from "color";
import { memoize } from "lodash";

export const LightAppCategoryColors = [
  "#FCFCFC",
  "#DBDBDB",
  "#FBE1E1",
  "#FBEBE2",
  "#FBF8E2",
  "#EBF8E7",
  "#E4F4F7",
  "#DFEAF7",
  "#ECE5F9",
  "#FFF0FC",
];

export const AppCategoryColors = [
  "#FCFCFC", // 0 white
  "#606060", // 1 grey
  "#DF2222", // 2 red
  "#E26722", // 3 orange
  "#E2CD2E", // 4 yellow
  "#67CA48", // 5 green
  "#56BFCC", // 6 cyan
  "#3280D6", // 7 blue
  "#723FD3", // 8 purple
  "#E400B7", // 9 pink
];
/** Semantic enum for app category colors */
export const AppCategoryColor = {
  White: AppCategoryColors[0],
  Grey: AppCategoryColors[1],
  Red: AppCategoryColors[2],
  Orange: AppCategoryColors[3],
  Yellow: AppCategoryColors[4],
  Green: AppCategoryColors[5],
  Cyan: AppCategoryColors[6],
  Blue: AppCategoryColors[7],
  Purple: AppCategoryColors[8],
  Pink: AppCategoryColors[9],
} as const;
export type AppCategoryColor =
  | "#FCFCFC"
  | "#606060"
  | "#DF2222"
  | "#E26722"
  | "#E2CD2E"
  | "#67CA48"
  | "#56BFCC"
  | "#3280D6"
  | "#723FD3"
  | "#E400B7";

export const lightenCategoryColor = memoize((color: string) => {
  const index = AppCategoryColors.indexOf(color);
  if (index != -1) {
    return LightAppCategoryColors[index];
  } else {
    const obj = Color(color);
    if (obj.isDark() || obj.lightness() < 0.6) {
      return obj.lightness(80).hex();
    } else {
      return color;
    }
  }
});

export const getColorName = memoize((color: string) => {
  switch (color) {
    case AppCategoryColor.White:
      return "White";
    case AppCategoryColor.Grey:
      return "Grey";
    case AppCategoryColor.Red:
      return "Red";
    case AppCategoryColor.Orange:
      return "Orange";
    case AppCategoryColor.Yellow:
      return "Yellow";
    case AppCategoryColor.Green:
      return "Green";
    case AppCategoryColor.Cyan:
      return "Cyan";
    case AppCategoryColor.Blue:
      return "Blue";
    case AppCategoryColor.Purple:
      return "Purple";
    case AppCategoryColor.Pink:
      return "Pink";
    default:
      return color;
  }
});
